import { useAuth } from '@/hooks/useAuth';
import { ROLES } from '@/lib/constants/app.constants';

/**
 * Hook to check if the current user has access to Size Charts feature.
 * Access is granted if any of the following conditions are met:
 * 1. User email domain is 28one.com (isInternal)
 * 2. User is a system admin
 * 3. Environment variable ENABLE_SIZECHARTS_PAGE is 'true'
 * 
 * @returns Object containing `hasSizeChartsAccess` boolean
 */
export const useSizeChartsAccess = () => {
  const { user } = useAuth();

  const hasSizeChartsAccess = (): boolean => {
    if (!user) {
      return false;
    }

    // Check if user is internal (email domain is 28one.com)
    const isInternal = user.isInternal === true;
    if (isInternal) {
      return true;
    }

    // Check if user is system admin
    const isSystemAdmin = user.roles?.includes(ROLES.SYSTEM_ADMIN) ?? false;
    if (isSystemAdmin) {
      return true;
    }

    // Check if feature flag env variable is enabled (defaults to false if not set)
    const featureFlagEnabled = __ENABLE_SIZECHARTS_PAGE__ === 'true';
    if (featureFlagEnabled) {
      return true;
    }

    return false;
  };

  return {
    hasSizeChartsAccess: hasSizeChartsAccess(),
  };
};
